export default __webpack_public_path__ + "static/media/Cabin1.a93081ab.jpg";